var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-dropdown-box list" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "tit" }, [
        _vm._v(_vm._s(/*거래내역*/ _vm.$t("PCOP-02-02-04-19")))
      ]),
      _c("i", {
        staticClass: "icon icon-dropdown-m-arrow",
        class: { rotate: !_vm.show4 },
        on: {
          click: function($event) {
            _vm.show4 = !_vm.show4
          }
        }
      })
    ]),
    _vm.show4
      ? _c(
          "div",
          { staticClass: "content" },
          [
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110010
              ? [
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("PCOP-02-03-05-18")))
                  ]),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-01-07"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                          " " +
                          _vm._s(
                            _vm.RCA040FA40Response.trsaccDrwotAcnAls &&
                              "(" +
                                _vm.RCA040FA40Response.trsaccDrwotAcnAls +
                                ")"
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*이체금액*/ _vm.$t("PCOP-02-03-01-08")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.cncycd) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.trsaccAmt))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수수료*/ _vm.$t("PCOP-02-03-01-09")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.cncycd) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.fee))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*송금메모*/ _vm.$t("PCOP-02-03-01-10")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtancMemoCtnt))
                    ])
                  ]),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*입금정보*/ _vm.$t("PCOP-02-03-05-19")))
                  ]),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*입금계좌번호*/ _vm.$t("PCOP-02-03-01-12"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.RCA040FA40Response.mnrcvAcno) +
                          " " +
                          _vm._s(
                            _vm.RCA040FA40Response.trsaccMnrcvAcnAls &&
                              "(" +
                                _vm.RCA040FA40Response.trsaccMnrcvAcnAls +
                                ")"
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인*/ _vm.$t("PCOP-02-03-01-13")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.ovsesTrsaccDraweFname)
                      )
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취인 참조내용*/ _vm.$t("PCOP-02-03-01-14"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.draweBnkbkRepsntCtnt)
                      )
                    ])
                  ])
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110020
              ? [
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(_vm.$t(/*출금계좌번호*/ "PCOP-02-03-02-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.dataGrid[0].drwotAcno)
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 이체금액*/ _vm.$t("PCOP-02-03-02-07")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.currencyCode) +
                          " " +
                          _vm._s(
                            _vm.$num(_vm.RCA040FA40Response.dTotalTrsaccAmt)
                          )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수수료*/ _vm.$t("PCOP-02-03-02-12")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.currencyCode) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.dTotalFeeAmt))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*이체결과*/ _vm.$t("PCOP-02-03-02-09")))
                  ]),
                  _vm._l(_vm.RCA040FA40Response.dataGrid, function(
                    list,
                    index
                  ) {
                    return [
                      _c(
                        "div",
                        { key: index, staticClass: "box-white -type4" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(list.mnrcvAcno) +
                                    "(" +
                                    _vm._s(list.cncycd) +
                                    ") "
                                ),
                                list.corpBsacRiStusDstcd == "1" &&
                                list.prcssStusDstcd == "1"
                                  ? [
                                      list.iBTelgmPrcssRsultCd == "0000"
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "state normal" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    /*정상*/ _vm.$t(
                                                      "PCOP-02-03-02-10"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "state warning" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    /*실패*/ _vm.$t(
                                                      "PCOP-02-03-02-20"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _c("div", { staticClass: "desc" }, [
                              _c("div", { staticClass: "item account" }, [
                                _vm._v(_vm._s(list.draweCustnm))
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _c("div", { staticClass: "account-info -type3" }, [
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*이체금액*/ _vm.$t("PCOP-02-03-02-11")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(
                                    _vm._s(list.cncycd) +
                                      " " +
                                      _vm._s(_vm.$num(list.trsaccAmt))
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*수수료*/ _vm.$t("PCOP-02-03-02-12")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(
                                    _vm._s(list.cncycd) +
                                      " " +
                                      _vm._s(_vm.$num(list.feeAmt))
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*수취인 참조내용*/ _vm.$t(
                                        "PCOP-02-03-02-13"
                                      )
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(_vm._s(list.draweBnkbkRepsntCtnt))
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*송금 메모*/ _vm.$t("PCOP-02-03-02-14")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(_vm._s(list.rmtancMemo))
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  })
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110030
              ? [
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-04-06"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                            " " +
                            _vm._s(
                              _vm.RCA040FA40Response.drwotAcnAls &&
                                "(" + _vm.RCA040FA40Response.drwotAcnAls + ")"
                            ) +
                            " "
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*이체금액*/ _vm.$t("PCOP-02-03-04-07")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.mnrcvAcnCncycd) +
                            " " +
                            _vm._s(_vm.$num(_vm.RCA040FA40Response.trsaccAmt))
                        )
                      ]),
                      _vm.RCA040FA40Response.drwotAcnCncycd !=
                      _vm.RCA040FA40Response.anticiAplyExrt
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /*출금예정금액*/ _vm.$t("PCOP-02-03-04-17")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.drwotAcnCncycd) +
                                  " " +
                                  _vm._s(
                                    _vm.$num(_vm.RCA040FA40Response.drwotzAmt)
                                  )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /*예상적용환율*/ _vm.$t("PCOP-02-03-04-18")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.anticiAplyExrt)
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(_vm._s(/*수수료*/ _vm.$t("PCOP-02-03-04-10")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.drwotAcnCncycd) +
                            " " +
                            _vm._s(_vm.$num(_vm.RCA040FA40Response.feeAmt))
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*송금메모*/ _vm.$t("PCOP-02-03-04-11")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.rmtancMemoCtnt))
                      ])
                    ],
                    2
                  ),
                  _c("br"),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*입금계좌번호*/ _vm.$t("PCOP-02-03-04-13"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.RCA040FA40Response.mnrcvAcno) +
                          " " +
                          _vm._s(
                            _vm.RCA040FA40Response.mnrcvAcnoAls &&
                              "(" + _vm.RCA040FA40Response.mnrcvAcnoAls + ")"
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인*/ _vm.$t("PCOP-02-03-04-14")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.draweFname))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취인 참조내용*/ _vm.$t("PCOP-02-03-04-15"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.draweBnkbkRepsntCtnt)
                      )
                    ])
                  ])
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110040
              ? [
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("PCOP-02-03-05-18")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-05-06"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                            " " +
                            _vm._s(
                              _vm.RCA040FA40Response.drwotAcnAls &&
                                "(" + _vm.RCA040FA40Response.drwotAcnAls + ")"
                            ) +
                            " "
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*이체금액*/ _vm.$t("PCOP-02-03-05-07")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.mnrcvCncycd) +
                            " " +
                            _vm._s(
                              _vm.$num(_vm.RCA040FA40Response.mnrcvTranAmt)
                            )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*예상수수료*/ _vm.$t("PCOP-02-03-05-08"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.drwotCncycd) +
                            " " +
                            _vm._s(_vm.$num(_vm.RCA040FA40Response.anticiFee))
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*송금메모*/ _vm.$t("PCOP-02-03-05-09")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.rmtancMemo))
                      ]),
                      _vm.siteCode == _vm.$config.SITECODE_OGMMR
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /** 송금목적 */ _vm.$t("MPAY-02-01-23-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.RCA040FA40Response.rmtancObjctvDsticCd +
                                      "_송금목적구분_MMR"
                                  )
                                )
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.siteCode == _vm.$config.SITECODE_OGHCM
                    ? [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("MFXD-01-02-02-08"))
                          }
                        })
                      ]
                    : _vm._e(),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*입금정보*/ _vm.$t("PCOP-02-03-05-19")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _vm.siteCode != _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*입금은행*/ _vm.$t("PCOP-02-03-05-11"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.mnrcvOthrBnkName)
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm.siteCode == _vm.$config.SITECODE_OGMMR ||
                      _vm.siteCode == _vm.$config.SITECODE_OGIND
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*입금 지점*/ _vm.$t("PCOP-02-03-05-20"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.mnrcvBrnCtnt)
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm.siteCode == _vm.$config.SITECODE_OGIND
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*IFSC 코드*/ _vm.$t("PCOP-02-03-05-21"))
                              )
                            ]),
                            _c("dd", [_vm._v(_vm._s("IFSC Code"))])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*입금계좌번호*/ _vm.$t("PCOP-02-03-05-12"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.RCA040FA40Response.mnrcvAcno) +
                            " " +
                            _vm._s(
                              _vm.RCA040FA40Response.mnrcvAcnoAls &&
                                "(" + _vm.RCA040FA40Response.mnrcvAcnoAls + ")"
                            ) +
                            " "
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*수취인*/ _vm.$t("PCOP-02-03-05-13")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvAcnDpstrName))
                      ]),
                      _vm.siteCode != _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /*수취인 참조내용*/ _vm.$t("PCOP-02-03-05-14")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.mnrcvDraweRefCtnt)
                              )
                            ])
                          ]
                        : [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /*Particulars */ _vm.$t("PCOP-02-03-06-11")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.mnrcvDraweRefCtnt)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /*수취인CODE*/ _vm.$t("PCOP-02-03-05-15")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.RCA040FA40Response.draweCd))
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*Reference*/ _vm.$t("PCOP-02-03-06-13"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.RCA040FA40Response.rmark50))
                            ])
                          ]
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110042
              ? [
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("PCOP-02-03-05-18")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-05-06"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                            " " +
                            _vm._s(
                              _vm.RCA040FA40Response.drwotAcnAls &&
                                "(" + _vm.RCA040FA40Response.drwotAcnAls + ")"
                            ) +
                            " "
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*이체금액*/ _vm.$t("PCOP-02-03-05-07")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.mnrcvCncycd) +
                            " " +
                            _vm._s(
                              _vm.$num(_vm.RCA040FA40Response.mnrcvTranAmt)
                            )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*예상수수료*/ _vm.$t("PCOP-02-03-05-08"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.drwotCncycd) +
                            " " +
                            _vm._s(_vm.$num(_vm.RCA040FA40Response.anticiFee))
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*송금메모*/ _vm.$t("PCOP-02-03-05-09")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.rmtancMemo))
                      ]),
                      _vm.siteCode == _vm.$config.SITECODE_OGMMR
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /** 송금목적 */ _vm.$t("MPAY-02-01-23-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.RCA040FA40Response.rmtancObjctvDsticCd +
                                      "_송금목적구분_MMR"
                                  )
                                )
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.siteCode == _vm.$config.SITECODE_OGHCM
                    ? [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("MFXD-01-02-02-08"))
                          }
                        })
                      ]
                    : _vm._e(),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*입금정보*/ _vm.$t("PCOP-02-03-05-19")))
                  ]),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(_vm._s(/*입금은행*/ _vm.$t("PCOP-02-03-05-11")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvOthrBnkName))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*입금 지점*/ _vm.$t("PCOP-02-03-05-20")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvBrnCtnt))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*입금계좌번호*/ _vm.$t("PCOP-02-03-05-12"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.RCA040FA40Response.mnrcvAcno) +
                          " " +
                          _vm._s(
                            _vm.RCA040FA40Response.mnrcvAcnoAls &&
                              "(" + _vm.RCA040FA40Response.mnrcvAcnoAls + ")"
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인*/ _vm.$t("PCOP-02-03-05-13")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvAcnDpstrName))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취인 참조내용*/ _vm.$t("PCOP-02-03-05-14"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvDraweRefCtnt))
                    ])
                  ])
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110041
              ? [
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("PCOP-02-03-05-18")))
                  ]),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-05-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                          " " +
                          _vm._s(
                            _vm.RCA040FA40Response.drwotAcnAls &&
                              "(" + _vm.RCA040FA40Response.drwotAcnAls + ")"
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*이체금액*/ _vm.$t("PCOP-02-03-05-07")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.mnrcvAcnCncycd) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.trsaccAmt))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*예상수수료*/ _vm.$t("PCOP-02-03-05-08")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.mnrcvAcnCncycd) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.rsultFee))
                      )
                    ])
                  ]),
                  _vm.siteCode == _vm.$config.SITECODE_OGHCM
                    ? [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("MFXD-01-02-02-08"))
                          }
                        })
                      ]
                    : _vm._e(),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*입금정보*/ _vm.$t("PCOP-02-03-05-19")))
                  ]),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(
                          _vm.RCA040FA40Response.recvCardAcc == "2"
                            ? /*입금계좌번호*/ _vm.$t("PCOP-02-03-05-12")
                            : /*입금카드번호*/ _vm.$t("MPAY-02-01-18-03")
                        )
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvAcno))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인*/ _vm.$t("PCOP-02-03-05-13")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.ovsesTrsaccDraweFname)
                      )
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취인 참조내용*/ _vm.$t("PCOP-02-03-05-14"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.draweRefCtnt))
                    ])
                  ])
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110050
              ? [
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("PCOP-02-03-05-18")))
                  ]),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-06-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                          " " +
                          _vm._s(
                            _vm.RCA040FA40Response.drwotAcnAls &&
                              "(" + _vm.RCA040FA40Response.drwotAcnAls + ")"
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*이체금액*/ _vm.$t("PCOP-02-03-06-07")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.cncycd) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.trsaccAmt))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*입금정보*/ _vm.$t("PCOP-02-03-05-19")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _vm.siteCode != _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*입금은행*/ _vm.$t("PCOP-02-03-05-11"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.rcevnBnkName)
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*입금계좌번호*/ _vm.$t("PCOP-02-03-05-12"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvAcno))
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*수취인*/ _vm.$t("PCOP-02-03-05-13")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.draweCustnm))
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*이체 시작일*/ _vm.$t("PCOP-02-03-06-18"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.trsaccStartYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*이체 종료일*/ _vm.$t("PCOP-02-03-06-19"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.trsaccEndYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*이체 주기*/ _vm.$t("PCOP-02-03-05-25")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$setTrsaccCyclDay(
                              _vm.RCA040FA40Response.dwkDstic,
                              _vm.RCA040FA40Response.pengagTrsaccRegiDd,
                              _vm.RCA040FA40Response.trsaccCyclUnitDstcd,
                              _vm.RCA040FA40Response.trsaccCyclUnit
                            )
                          )
                        )
                      ]),
                      _vm.siteCode != _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /*휴일인 경우*/ _vm.$t("PCOP-02-03-06-16")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.RCA040FA40Response.holdyTrsaccDstcd +
                                      "_휴일이체구분코드"
                                  )
                                )
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(_vm._s(/*등록일시*/ _vm.$t("PCOP-02-03-05-26")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.aBTRegiYmd
                            )
                          )
                        )
                      ])
                    ],
                    2
                  ),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*참조 정보*/ _vm.$t("PCOP-02-03-05-22")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _vm.siteCode == _vm.$config.SITECODE_OGMMR
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /* 송금 목적 */ _vm.$t("MPAY-02-01-23-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.RCA040FA40Response.trsaccApctRefCtnt1
                                )
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(
                            /*particulars/수취인참조내용 */ _vm.siteCode !=
                              _vm.$config.SITECODE_OGAUC
                              ? _vm.$t("PCOP-02-03-05-14")
                              : _vm.$t("PCOP-02-03-06-11")
                          )
                        )
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.draweRefCtnt))
                      ]),
                      _vm.siteCode == _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*Code*/ _vm.$t("PCOP-02-03-06-12"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.draweRefCtnt2)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /**Reference*/ _vm.$t("PCOP-02-03-06-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.draweRefCtnt3)
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110051
              ? [
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("PCOP-02-03-05-18")))
                  ]),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-06-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                          " " +
                          _vm._s(
                            _vm.RCA040FA40Response.drwotAcnAls &&
                              "(" + _vm.RCA040FA40Response.drwotAcnAls + ")"
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*이체금액*/ _vm.$t("PCOP-02-03-06-07")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.cncycd) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.trsaccAmt))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*입금정보*/ _vm.$t("PCOP-02-03-05-19")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _vm.siteCode != _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*입금은행*/ _vm.$t("PCOP-02-03-05-11"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.rcevnBnkName)
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*입금계좌번호*/ _vm.$t("PCOP-02-03-05-12"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvAcno))
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*수취인*/ _vm.$t("PCOP-02-03-05-13")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.draweCustnm))
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*이체 시작일*/ _vm.$t("PCOP-02-03-06-18"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.trsaccStartYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*이체 종료일*/ _vm.$t("PCOP-02-03-06-19"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.trsaccEndYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*이체 주기*/ _vm.$t("PCOP-02-03-05-25")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$setTrsaccCyclDay(
                              _vm.RCA040FA40Response.dwkDstic,
                              _vm.RCA040FA40Response.aBTDd,
                              _vm.RCA040FA40Response.trsaccCyclUnitDstcd,
                              _vm.RCA040FA40Response.trsaccCyclUnit
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*신청일*/ _vm.$t("PCOP-02-03-05-27")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.aBTRegiYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*해지일*/ _vm.$t("PCOP-02-03-05-28")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.RegiYmd
                            )
                          )
                        )
                      ])
                    ],
                    2
                  ),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*참조 정보*/ _vm.$t("PCOP-02-03-05-19")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _vm.siteCode == _vm.$config.SITECODE_OGMMR
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /* 송금 목적 */ _vm.$t("MPAY-02-01-23-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.RCA040FA40Response.trsaccApctRefCtnt1
                                )
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(
                            /*particulars/수취인참조내용 */ _vm.siteCode !=
                              _vm.$config.SITECODE_OGAUC
                              ? _vm.$t("PCOP-02-03-05-14")
                              : _vm.$t("PCOP-02-03-06-11")
                          )
                        )
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.draweRefCtnt))
                      ]),
                      _vm.siteCode == _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*Code*/ _vm.$t("PCOP-02-03-06-12"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.draweRefCtnt2)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /**Reference*/ _vm.$t("PCOP-02-03-06-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.draweRefCtnt3)
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateYmd(
                              _vm.RCA040DA40Response.prcssFnshYMS
                            )
                          )
                        )
                      ])
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110052
              ? [
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("PCOP-02-03-05-18")))
                  ]),
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-06-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                          " " +
                          _vm._s(
                            _vm.RCA040FA40Response.drwotAcnAls &&
                              "(" + _vm.RCA040FA40Response.drwotAcnAls + ")"
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*이체금액*/ _vm.$t("PCOP-02-03-06-07")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.cncycd) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.trsaccAmt))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*입금정보*/ _vm.$t("PCOP-02-03-05-19")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _vm.siteCode != _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*입금은행*/ _vm.$t("PCOP-02-03-05-11"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.rcevnBnkName)
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*입금계좌번호*/ _vm.$t("PCOP-02-03-05-12"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvAcno))
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*수취인*/ _vm.$t("PCOP-02-03-05-13")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.draweCustnm))
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*이체 시작일*/ _vm.$t("PCOP-02-03-06-18"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.trsaccStartYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*이체 종료일*/ _vm.$t("PCOP-02-03-06-19"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.trsaccEndYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*이체 주기*/ _vm.$t("PCOP-02-03-05-25")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$setTrsaccCyclDay(
                              _vm.RCA040FA40Response.dwkDstic,
                              _vm.RCA040FA40Response.pengagTrsaccRegiDd,
                              _vm.RCA040FA40Response.trsaccCyclUnitDstcd,
                              _vm.RCA040FA40Response.trsaccCyclUnit
                            )
                          )
                        )
                      ]),
                      _vm.siteCode != _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /*휴일인 경우*/ _vm.$t("PCOP-02-03-06-16")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.RCA040FA40Response.holdyTrsaccDstcd +
                                      "_휴일이체구분코드"
                                  )
                                )
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(_vm._s(/*등록일시*/ _vm.$t("PCOP-02-03-05-26")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.aBTRegiYmd
                            )
                          )
                        )
                      ])
                    ],
                    2
                  ),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*참조 정보*/ _vm.$t("PCOP-02-03-05-22")))
                  ]),
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _vm.siteCode == _vm.$config.SITECODE_OGMMR
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /* 송금 목적 */ _vm.$t("MPAY-02-01-23-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.RCA040FA40Response.trsaccApctRefCtnt1
                                )
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(
                            /*particulars/수취인참조내용 */ _vm.siteCode !=
                              _vm.$config.SITECODE_OGAUC
                              ? _vm.$t("PCOP-02-03-05-14")
                              : _vm.$t("PCOP-02-03-06-11")
                          )
                        )
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.draweRefCtnt))
                      ]),
                      _vm.siteCode == _vm.$config.SITECODE_OGAUC
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*Code*/ _vm.$t("PCOP-02-03-06-12"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.draweRefCtnt2)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  /**Reference*/ _vm.$t("PCOP-02-03-06-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.draweRefCtnt3)
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd == "110060" ? void 0 : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd == "110061" ? void 0 : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_110070 ||
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_110071
              ? [
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-08-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.apctAcitmNo))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*송금할 외화금액*/ _vm.$t("PCOP-02-03-08-07"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.cncycd) +
                          " " +
                          _vm._s(
                            _vm.$num(_vm.RCA040FA40Response.outwdRmtancAmt)
                          )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*송금수수료*/ _vm.$t("PCOP-02-03-08-08")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.ovsesRmtancFeeCncycd) +
                          " " +
                          _vm._s(
                            _vm.$num(_vm.RCA040FA40Response.ovsesRmtancFeeAmt)
                          )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*전신료*/ _vm.$t("PCOP-02-03-08-09")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.ovsesRmtancTxfeCncycd) +
                          " " +
                          _vm._s(
                            _vm.$num(_vm.RCA040FA40Response.ovsesRmtancTxfeAmt)
                          )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*중계수수료*/ _vm.$t("PCOP-02-03-08-10")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            _vm.RCA040FA40Response.fXFeeBrdnDsticCd +
                              "_수수료부담구분"
                          )
                        )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*송금구분*/ _vm.$t("PCOP-02-03-08-12")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            _vm.RCA040FA40Response.rmtancObjctvDsticCd +
                              "_송금목적구분"
                          )
                        )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(
                          /*수취 은행 BIC 코드*/ _vm.$t("PCOP-02-03-08-15")
                        )
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.pybnkBIC))]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취 은행명*/ _vm.$t("PCOP-02-03-08-16")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.pybnkName))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취 은행주소*/ _vm.$t("PCOP-02-03-08-17"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.paymtBnkzAddrCtnt1))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취 은행주소*/ _vm.$t("PCOP-02-03-08-17"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.paymtBnkzAddrCtnt2))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취은행 도시*/ _vm.$t("MFXD-02-04-01-03"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.paymtBnkzAddrCtnt3))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취 은행번호*/ _vm.$t("PCOP-02-03-08-18"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.indicMatrCtnt1))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취은행 소재지*/ _vm.$t("PCOP-02-03-08-19"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            _vm.RCA040FA40Response.pybnkISONatnlCd + "_국가코드"
                          )
                        )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취인 계좌번호*/ _vm.$t("PCOP-02-03-08-20"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.draweAcitmNo))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인 성명*/ _vm.$t("PCOP-02-03-08-21")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.draweCustnm))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*수취인 전화번호*/ _vm.$t("PCOP-02-03-08-22"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.indicMatrCtnt6))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인 주소*/ _vm.$t("PCOP-02-03-08-23")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.draweAddrCtnt1))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인 주소*/ _vm.$t("PCOP-02-03-08-23")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.draweAddrCtnt2))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인 도시*/ _vm.$t("MFXD-02-04-01-01")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.draweAddrCtnt3))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인 국가*/ _vm.$t("MFXD-02-04-01-02")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.draweISONatnlCd))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*송금의뢰인 성명*/ _vm.$t("PCOP-02-03-08-25"))
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.rmtrName))]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(
                          /*송금의뢰인 전화번호*/ _vm.$t("PCOP-02-03-08-26")
                        )
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.ovsesRmtancApctTelno)
                      )
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*송금의뢰인 주소*/ _vm.$t("PCOP-02-03-08-27"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtrAddrCtnt1))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*송금의뢰인 주소*/ _vm.$t("PCOP-02-03-08-27"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtrAddrCtnt2))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(
                          /*송금의뢰인 도시(영문)*/ _vm.$t("MFXD-02-04-01-05")
                        )
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtrAddrCtnt3))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*송금의뢰인 국가*/ _vm.$t("MFXD-02-04-01-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtrISONatnlCd))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*적요*/ _vm.$t("PCOP-02-03-08-28")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtancRelatdCtnt1))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*적요*/ _vm.$t("PCOP-02-03-08-28")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtancRelatdCtnt2))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*적요*/ _vm.$t("PCOP-02-03-08-28")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtancRelatdCtnt3))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*적요*/ _vm.$t("PCOP-02-03-08-28")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040FA40Response.rmtancRelatdCtnt4))
                    ])
                  ])
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_110080 ||
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_110081
              ? [
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(_vm.$t(/*출금계좌번호*/ "PCOP-02-03-03-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.dataGrid[0].drwotAcno)
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 이체금액*/ _vm.$t("PCOP-02-03-03-07")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.currencyCode) +
                          " " +
                          _vm._s(
                            _vm.$num(_vm.RCA040FA40Response.dTotalTrsaccAmt)
                          )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수수료*/ _vm.$t("PCOP-02-03-03-08")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.currencyCode) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.dTotalFeeAmt))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*이체결과*/ _vm.$t("PCOP-02-03-03-09")))
                  ]),
                  _vm._l(_vm.RCA040FA40Response.dataGrid, function(
                    list,
                    index
                  ) {
                    return [
                      _c(
                        "div",
                        { key: index, staticClass: "box-white -type4" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(list.mnrcvAcno) +
                                    "(" +
                                    _vm._s(list.cncycd) +
                                    ") "
                                ),
                                list.corpBsacRiStusDstcd == "1" &&
                                list.prcssStusDstcd == "1"
                                  ? [
                                      _vm.RCA040DA40Response.corpBzwkCd ==
                                      _vm.$config.CORP_BZWK_APRVALCD_110081
                                        ? [
                                            "0|1|2|3|4|5|A".includes(
                                              _vm.RBF1605T41Response
                                                .untcTrsaccPrgrsDstcd
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "state normal"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.RBF1605T41Response
                                                            .untcTrsaccPrgrsDstcd +
                                                            "_otrQtStat"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "state warning"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.RBF1605T41Response
                                                            .untcTrsaccPrgrsDstcd +
                                                            "_otrQtStat"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                          ]
                                        : [
                                            list.iBTelgmPrcssRsultCd == "0000"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "state normal"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          /*정상*/ _vm.$t(
                                                            "PCOP-02-03-03-10"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "state warning"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          /*실패*/ _vm.$t(
                                                            "PCOP-02-03-03-16"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                          ]
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _c("div", { staticClass: "desc" }, [
                              _c("div", { staticClass: "item account" }, [
                                _vm._v(_vm._s(list.draweCustnm))
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _c("div", { staticClass: "account-info -type3" }, [
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(/*은행명*/ "PCOP-02-03-03-11")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(_vm._s(list.mnrcvOthrBnkName))
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*이체금액*/ _vm.$t("PCOP-02-03-03-12")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(
                                    _vm._s(list.cncycd) +
                                      " " +
                                      _vm._s(_vm.$num(list.trsaccAmt))
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*수수료*/ _vm.$t("PCOP-02-03-03-13")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(
                                    _vm._s(list.cncycd) +
                                      " " +
                                      _vm._s(_vm.$num(list.feeAmt))
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*수취인 참조내용*/ _vm.$t(
                                        "PCOP-02-03-03-14"
                                      )
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(_vm._s(list.draweBnkbkRepsntCtnt))
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*송금 메모*/ _vm.$t("PCOP-02-03-03-15")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(_vm._s(list.rmtancMemo))
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  })
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110082
              ? [
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(_vm.$t(/*출금계좌번호*/ "PCOP-02-03-03-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.dataGrid[0].drwotAcno)
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 이체금액*/ _vm.$t("MCOM-0000201")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        " MMK " +
                          _vm._s(
                            _vm.$num(
                              _vm._.map(
                                _vm.RCA040FA40Response.dataGrid,
                                function(v) {
                                  var trsaccAmt = v.trsaccAmt
                                  return trsaccAmt
                                }
                              ).reduce(function(a, b) {
                                return a + b
                              }, 0)
                            )
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 이체 수수료*/ _vm.$t("MCOM-0000202")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        " MMK " +
                          _vm._s(
                            _vm.$num(
                              _vm._.map(
                                _vm.RCA040FA40Response.dataGrid,
                                function(v) {
                                  var feeAmt = v.feeAmt
                                  return feeAmt
                                }
                              ).reduce(function(a, b) {
                                return a + b
                              }, 0)
                            )
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 건수*/ _vm.$t("MCOM-0000200")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.$num(_vm.RCA040FA40Response.totalLineCnt, 0))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*이체일*/ _vm.$t("MCOM-0000204")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.$getGlobalDateFmt(
                            _vm.RCA040FA40Response.dataGrid[0].salryDate
                          )
                        )
                      )
                    ]),
                    _vm.RCA040DA40Response.lastPrcssStusDstcd == "20" &&
                    "salryTrsaccMgtNo" in this.RCA040FA40Response.dataGrid[0]
                      ? _c("dt", [
                          _vm._v(
                            _vm._s(/*급여이체 관리번호*/ _vm.$t("MCOM-0000203"))
                          )
                        ])
                      : _vm._e(),
                    _vm.RCA040DA40Response.lastPrcssStusDstcd == "20" &&
                    "salryTrsaccMgtNo" in this.RCA040FA40Response.dataGrid[0]
                      ? _c("dd", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.RCA040FA40Response.dataGrid[0]
                                  .salryTrsaccMgtNo
                              ) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "sub-tit" }, [
                    _vm._v(_vm._s(/*이체결과*/ _vm.$t("PCOP-02-03-03-09")))
                  ]),
                  _vm._l(_vm.RCA040FA40Response.dataGrid, function(
                    list,
                    index
                  ) {
                    return [
                      _c(
                        "div",
                        { key: index, staticClass: "box-white -type4" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(list.mnrcvAcno) +
                                    "(" +
                                    _vm._s(list.cncycd) +
                                    ") "
                                ),
                                list.corpBsacRiStusDstcd == "1" &&
                                list.prcssStusDstcd == "1"
                                  ? [
                                      _vm.RCA040DA40Response
                                        .lastPrcssStusDstcd == "20"
                                        ? [
                                            !_vm._.isEmpty(
                                              _vm.RBF1605T41Response
                                            )
                                              ? [
                                                  "0|1|2|4".includes(
                                                    _vm.RBF1605T41Response
                                                      .gridDtail[index]
                                                      .brncoSalryTranStusDstcd
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "state normal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  _vm
                                                                    .RBF1605T41Response
                                                                    .gridDtail[
                                                                    index
                                                                  ]
                                                                    .brncoSalryTranStusDstcd +
                                                                    "_mmrSalary"
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    : "3|9".includes(
                                                        _vm.RBF1605T41Response
                                                          .gridDtail[index]
                                                          .brncoSalryTranStusDstcd
                                                      )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "state warning"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  _vm
                                                                    .RBF1605T41Response
                                                                    .gridDtail[
                                                                    index
                                                                  ]
                                                                    .brncoSalryTranStusDstcd +
                                                                    "_mmrSalary"
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "state warning"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            /*오류*/ _vm.$t(
                                                              "PCOP-02-03-03-18"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                          ]
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _c("div", { staticClass: "desc" }, [
                              _c("div", { staticClass: "item account" }, [
                                _vm._v(_vm._s(list.ovsesCustOcntryName))
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _c("div", { staticClass: "account-info -type3" }, [
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(/*은행명*/ "PCOP-02-03-03-11")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(_vm._s(list.bnkName))
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*이체금액*/ _vm.$t("PCOP-02-03-03-12")
                                    )
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(
                                    _vm._s(list.cncycd) +
                                      " " +
                                      _vm._s(_vm.$num(list.trsaccAmt))
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(
                                      /*수수료*/ _vm.$t("PCOP-02-03-03-13")
                                    )
                                  )
                                ]),
                                list.feeAmt != null
                                  ? _c("span", { staticClass: "dec" }, [
                                      _vm._v(
                                        _vm._s(list.cncycd) +
                                          " " +
                                          _vm._s(_vm.$num(list.feeAmt))
                                      )
                                    ])
                                  : _c("span", { staticClass: "dec" }, [
                                      _vm._v(
                                        _vm._s(list.cncycd) +
                                          " " +
                                          _vm._s(_vm.$num(0))
                                      )
                                    ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _c("span", { staticClass: "tit" }, [
                                  _vm._v(
                                    _vm._s(/*비고*/ _vm.$t("MPAY-02-01-25-13"))
                                  )
                                ]),
                                _c("span", { staticClass: "dec" }, [
                                  _vm._v(_vm._s(list.inotBasiSumryCtnt))
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  })
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_120010
              ? [
                  _vm.RCA040FA40Response.dpostTermiUpdatDstcd == "1" /*해지*/
                    ? [
                        _c(
                          "dl",
                          { staticClass: "dlist dlist-item--type4" },
                          [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*해지계좌번호*/ "MDEP-02-01-10-04")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.termiUpdatAcno)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*해지계좌명*/ "MDEP-02-01-10-05")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.termiUpdatAcnName)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*해지일*/ "MDEP-02-01-10-06"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$getGlobalDateFmt(
                                    _vm.RCA040FA40Response.termiYmd
                                  )
                                )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*해지구분*/ "MDEP-02-01-10-19"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.RCA040FA40Response.termiTimgDstcd +
                                      "_해지시기구분코드"
                                  )
                                )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*원금*/ "MDEP-01-01-07-09"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(_vm.$num(_vm.RCA040FA40Response.prcpl))
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*이자*/ "MDEP-01-01-07-10"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(
                                    _vm.$num(_vm.RCA040FA40Response.intAmt)
                                  )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*징수세금*/ "MDEP-01-01-07-11"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(
                                    _vm.$num(_vm.RCA040FA40Response.levyTax)
                                  )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*총지급금액*/ "PCOP-02-03-09-18")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(
                                    _vm.$num(
                                      _vm.RCA040FA40Response.totalzPaymtAmt
                                    )
                                  )
                              )
                            ]),
                            _vm.RCA040FA40Response.mnrcvAcnCncycd !=
                            _vm.RCA040FA40Response.cncycd
                              ? [
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*예상입금금액*/ "PCOP-02-03-09-30"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.RCA040FA40Response.mnrcvAcnCncycd
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm.$num(
                                            _vm.RCA040FA40Response.anticiMrvamt
                                          )
                                        )
                                    )
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*예상적용환율*/ "PCOP-02-03-09-27"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.RCA040FA40Response.anticiAplyExrt
                                      )
                                    )
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*예상수수료*/ "PCOP-02-03-09-28"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(_vm.RCA040FA40Response.cncycd) +
                                        " " +
                                        _vm._s(
                                          _vm.$num(
                                            _vm.RCA040FA40Response.anticiFee
                                          )
                                        )
                                    )
                                  ])
                                ]
                              : _vm._e(),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*입금계좌번호*/ "MPAY-02-01-25-09")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.RCA040FA40Response.mnrcvAcno))
                            ])
                          ],
                          2
                        )
                      ]
                    : [
                        _vm._v(" \\ "),
                        _c(
                          "dl",
                          { staticClass: "dlist dlist-item--type4" },
                          [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*갱신계좌번호*/ "PCOP-02-03-09-07")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.termiUpdatAcno)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*갱신계좌명*/ "PCOP-02-03-09-08")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.termiUpdatAcnName)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*재예치구분*/ "PCOP-02-03-09-10")
                                )
                              )
                            ]),
                            _c(
                              "dd",
                              [
                                _vm.RCA040FA40Response.expirExtenTagetDstcd ==
                                "1"
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            /*원금만예치*/ "PCOP-02-03-09-15"
                                          )
                                        )
                                      )
                                    ]
                                  : _vm.RCA040FA40Response
                                      .expirExtenTagetDstcd == "2"
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            /*원금 + 이자예치*/ "MDEP-02-01-13-16"
                                          )
                                        )
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*재예치기간*/ "MDEP-02-01-13-07")
                                ) +
                                  "(" +
                                  _vm._s(
                                    _vm.$t(
                                      _vm.RCA040FA40Response.brncoCyclDstcd +
                                        "_BO주기구분코드"
                                    )
                                  ) +
                                  ")"
                              )
                            ]),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.RCA040FA40Response.ctrcTrmCnt))
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*이자지급방법*/ "PCOP-02-03-09-13")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.RCA040FA40Response.dpostIntPaymtDstcd +
                                      "_이자지급방식"
                                  )
                                )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*원금*/ "MDEP-01-01-07-09"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(_vm.$num(_vm.RCA040FA40Response.prcpl))
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*이자*/ "MDEP-01-01-07-10"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(
                                    _vm.$num(_vm.RCA040FA40Response.intAmt)
                                  )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*징수세금*/ "MDEP-01-01-07-11"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(
                                    _vm.$num(_vm.RCA040FA40Response.levyTax)
                                  )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*총지급금액*/ "PCOP-02-03-09-18")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(
                                    _vm.$num(
                                      _vm.RCA040FA40Response.totalzPaymtAmt
                                    )
                                  )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*재예치금액*/ "PCOP-02-03-09-20")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$num(_vm.RCA040FA40Response.reDtmnAmt)
                                )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*갱신일*/ "PCOP-02-03-09-21"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$getGlobalDateFmt(
                                    _vm.RCA040FA40Response.updatYmd
                                  )
                                )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*만기일*/ "PCOP-02-03-09-22"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$getGlobalDateFmt(
                                    _vm.RCA040FA40Response.expirYmd
                                  )
                                )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(_vm.$t(/*적용이율*/ "PCOP-02-03-09-23"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$num(_vm.RCA040FA40Response.updatAplyIrt)
                                ) + "%"
                              )
                            ]),
                            _vm.RCA040FA40Response.expirExtenTagetDstcd == "1"
                              ? [
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*이자입금금액*/ "PCOP-02-03-09-31"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.RCA040FA40Response.mnrcvAcnCncycd
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm.$num(
                                            _vm.RCA040FA40Response.paymtIntAmt
                                          )
                                        )
                                    )
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*이자입금계좌번호*/ "PCOP-02-03-09-25"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(_vm.RCA040FA40Response.mnrcvAcno)
                                    )
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*예상이자입금금액*/ "PCOP-02-03-09-26"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.RCA040FA40Response.mnrcvAcnCncycd
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm.$num(
                                            _vm.RCA040FA40Response
                                              .anticiIntMrvamt
                                          )
                                        )
                                    )
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*예상적용환율*/ "PCOP-02-03-09-27"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.RCA040FA40Response.anticiAplyExrt
                                      )
                                    )
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*예상수수료*/ "PCOP-02-03-09-28"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.RCA040FA40Response.mnrcvAcnCncycd
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm.$num(
                                            _vm.RCA040FA40Response.anticiFee
                                          )
                                        )
                                    )
                                  ])
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_130010
              ? [
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.$t(/*대출계좌번호*/ "MLON-01-01-11-03"))
                        )
                      ]),
                      _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.lnAcno))]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.$t(/*출금계좌번호*/ "MLON-01-01-11-04"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.drwotAcno))
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*예금주명*/ "MLON-01-01-11-05")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.lnAcnDpstrName
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*상환일*/ "MLON-01-01-14-03")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.rpayYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*거래종류*/ "PCOP-01-01-02-03")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.RCA040FA40Response
                                .brncoAcitmTranIdnfiPtrnDstcd +
                                "_BO계정거래식별유형"
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.$t(/*총상환금액*/ "MLON-01-01-14-08"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.cncycd) +
                            " " +
                            _vm._s(
                              _vm.$num(_vm.RCA040FA40Response.rpayTotalzAmt)
                            )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*원금*/ "MLON-01-01-04-05")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.cncycd) +
                            " " +
                            _vm._s(
                              _vm.$num(_vm.RCA040FA40Response.rpayPrcplAmt)
                            )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*약정이자*/ "MLON-01-01-04-06")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.cncycd) +
                            " " +
                            _vm._s(
                              _vm.$num(_vm.RCA040FA40Response.totalzPaymtAmt)
                            )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*연체이자*/ "MLON-01-01-04-07")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.cncycd) +
                            " " +
                            _vm._s(_vm.$num(_vm.RCA040FA40Response.rpayzInt))
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*환급이자*/ "MLON-01-01-15-06")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.cncycd) +
                            " " +
                            _vm._s(_vm.$num(_vm.RCA040FA40Response.mnyrtnInt))
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.$t(/*조기상환수수료*/ "MLON-01-01-15-07"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.lnCncycd) +
                            " " +
                            _vm._s(_vm.$num(_vm.RCA040FA40Response.elyRpayFee))
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*대출잔액*/ "MLON-01-01-15-08")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.cncycd) +
                            " " +
                            _vm._s(_vm.$num(_vm.RCA040FA40Response.lnBal))
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t(/*대출이율*/ "MINQ-01-01-10-14")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.ovsesInln) + "%")
                      ]),
                      _vm.RCA040FA40Response.cncycd !=
                      _vm.RCA040FA40Response.lnCncycd
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*예상출금금액*/ "MPAY-02-01-25-18")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.lnCncycd) +
                                  " " +
                                  _vm._s(_vm.RCA040FA40Response.anticiDrwotAmt)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*예상적용환율*/ "PCOP-02-03-04-09")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.anticiAplyExrt)
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(/*예상수수료*/ "PCOP-02-03-09-28")
                                )
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.lnCncycd) +
                                  " " +
                                  _vm._s(_vm.RCA040FA40Response.anticiFee)
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.$t(/*이자계산시작일*/ "MLON-01-01-10-15"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.intCalcStartYmd
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.$t(/*이자계산종료일*/ "MLON-01-01-10-16"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$getGlobalDateFmt(
                              _vm.RCA040FA40Response.intCalcEndYmd
                            )
                          )
                        )
                      ])
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110011
              ? [
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-03-06"))
                      )
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                          " (" +
                          _vm._s(_vm.RCA040FA40Response.drwotAcnAls) +
                          ")"
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 결제금액*/ _vm.$t("MPAY-06-01-01-56")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040FA40Response.drwotCncycd) +
                          " " +
                          _vm._s(_vm.$num(_vm.RCA040FA40Response.chrgAmt))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*서비스 구분*/ _vm.$t("MPAY-06-01-01-57")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(/*휴대폰 요금충전*/ _vm.$t("MPAY-06-01-01-07"))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*휴대폰번호*/ _vm.$t("MPAY-06-01-01-44")))
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.cphnNo))]),
                    _c("dt", [
                      _vm._v(_vm._s(/*통신사*/ _vm.$t("MPAY-06-01-01-45")))
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.telcmNm))])
                  ])
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
            _vm.$config.CORP_BZWK_APRVALCD_110012
              ? [
                  _c(
                    "dl",
                    { staticClass: "dlist dlist-item--type4" },
                    [
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*서비스 구분*/ _vm.$t("MPAY-06-01-01-57"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.RCA040FA40Response.paymtDsticCd == 1
                              ? _vm.$t("MPAY-06-01-01-18")
                              : _vm.$t("MPAY-06-01-01-21")
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*출금계좌번호*/ _vm.$t("PCOP-02-03-03-06"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.drwotAcno) +
                            " (" +
                            _vm._s(_vm.RCA040FA40Response.drwotAcnAls) +
                            ")"
                        )
                      ]),
                      this.RCA040FA40Response.paymtDsticCd == 2
                        ? [
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*결제금액*/ _vm.$t("MPAY-06-01-01-54"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(
                                    _vm.$num(_vm.RCA040FA40Response.paymtAmt)
                                  )
                              )
                            ]),
                            _c("dt", [
                              _vm._v(
                                _vm._s(/*수수료*/ _vm.$t("MPAY-06-01-01-55"))
                              )
                            ]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.RCA040FA40Response.cncycd) +
                                  " " +
                                  _vm._s(_vm.$num(_vm.RCA040FA40Response.fee))
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*총 결제금액*/ _vm.$t("MPAY-06-01-01-56"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.RCA040FA40Response.cncycd) +
                            " " +
                            _vm._s(
                              _vm.$num(_vm.RCA040FA40Response.totalPaymtAmt)
                            )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*서비스 제공업체*/ _vm.$t("MPAY-06-01-01-58"))
                        )
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.RCA040FA40Response.paymtInstiName))
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(/*납부자코드*/ _vm.$t("MPAY-06-01-01-32"))
                        )
                      ]),
                      _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.prCd))]),
                      _c("dt", [
                        _vm._v(_vm._s(/*고객명*/ _vm.$t("MPAY-06-01-01-60")))
                      ]),
                      _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.custnm))]),
                      _c("dt", [
                        _vm._v(_vm._s(/*청구월*/ _vm.$t("MPAY-06-01-01-62")))
                      ]),
                      _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.askCycl))])
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_140001 ||
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_140002 ||
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_140003 ||
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_140004
              ? [
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*사용자명*/ _vm.$t("MOTP-FRT-03-01-01-24"))
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.userName))]),
                    _c("dt", [
                      _vm._v(_vm._s(/*사용자 ID*/ _vm.$t("EKYC-15-04")))
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.uid))]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*직급 및 기타 정보*/ _vm.$t("PCOP-02-03-03-19"))
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.rmark))]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(
                          /*등록할 OTP일련번호*/ _vm.$t("PCOP-02-03-03-20")
                        )
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.otpSerno))])
                  ])
                ]
              : _vm._e(),
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_140005 ||
            _vm.RCA040DA40Response.corpBzwkCd ==
              _vm.$config.CORP_BZWK_APRVALCD_140006
              ? [
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*사용자명*/ _vm.$t("MOTP-FRT-03-01-01-24"))
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.userName))]),
                    _c("dt", [
                      _vm._v(_vm._s(/*사용자 ID*/ _vm.$t("EKYC-15-04")))
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.uid))]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*직급 및 기타 정보*/ _vm.$t("PCOP-02-03-03-19"))
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.RCA040FA40Response.rmark))]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*기존 OTP 종류*/ _vm.$t("PCOP-02-03-03-21"))
                      )
                    ]),
                    _vm.RCA040FA40Response.otpVndrDsticCd !== "" &&
                    _vm.RCA040FA40Response.deleteOtpVndrDsticCd !== ""
                      ? _c("dd", [
                          _vm._v(
                            _vm._s(
                              _vm.RCA040DA40Response.corpBzwkCd ==
                                _vm.$config.CORP_BZWK_APRVALCD_140005
                                ? _vm.$t(
                                    _vm.RCA040FA40Response.otpVndrDsticCd +
                                      "_OTP밴더구분코드"
                                  )
                                : _vm.$t(
                                    _vm.RCA040FA40Response
                                      .deleteOtpVndrDsticCd + "_OTP밴더구분코드"
                                  )
                            )
                          )
                        ])
                      : _c("dd", [_vm._v("-")]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*기존 OTP 일련번호*/ _vm.$t("PCOP-02-03-03-22"))
                      )
                    ]),
                    _vm.RCA040FA40Response.otpSerno !== "" &&
                    _vm.RCA040FA40Response.deleteOtpSerno !== ""
                      ? _c("dd", [
                          _vm._v(
                            _vm._s(
                              _vm.RCA040DA40Response.corpBzwkCd ==
                                _vm.$config.CORP_BZWK_APRVALCD_140005
                                ? _vm.RCA040FA40Response.otpSerno
                                : _vm.RCA040FA40Response.deleteOtpSerno
                            )
                          )
                        ])
                      : _c("dd", [_vm._v("-")])
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }